import type { InputHTMLAttributes, ReactNode, Ref } from "react";
import { cx } from "../../lib/cx";

export type InputProps = {
  leadingIcon?: ReactNode;
  trailingAction?: ReactNode;
  invalid?: boolean;
  ref?: Ref<HTMLInputElement>;
} & Omit<InputHTMLAttributes<HTMLInputElement>, "size">;

export const Input = ({
  leadingIcon,
  trailingAction,
  invalid = false,
  type = "text",
  className,
  ref,
  ...rest
}: InputProps) => {
  const hasAffix = Boolean(leadingIcon || trailingAction);
  return (
    <div
      data-state={invalid ? "error" : "default"}
      className={cx(hasAffix && "input-group", invalid && hasAffix && "has-validation", className)}
    >
      {leadingIcon && <span className="input-group-text">{leadingIcon}</span>}
      <input
        ref={ref}
        type={type}
        className={cx("form-control", invalid && "is-invalid")}
        {...rest}
      />
      {trailingAction && <span className="input-group-text">{trailingAction}</span>}
    </div>
  );
};
